module.exports = __webpack_public_path__ + "static/media/background.36899723.png";